import React from 'react';
import ContentLoader from 'react-content-loader';

import { imageSize } from '@common/react/utils/utils';
import Colorbox from '@common/react/components/UI/Colorbox/Colorbox';

import { Certificate } from '@commonTuna/react/objects/Certificate';
import { DoctorCertificate } from '@commonTuna/react/objects/DoctorCertificate';
import ImageWithSkeleton from '@commonTuna/react/components/UI/ImageWithSkeleton/ImageWithSkeleton';

interface Props {
	items: Array<DoctorCertificate>;
}

interface CertificateProps {
	item: Certificate;
	onClick: () => void;
}

const CertificateComponent: React.FC<CertificateProps> = ({ item, onClick }) => {
	const [loading, setLoading] = React.useState(true);
	const [visible, setVisible] = React.useState(false);

	React.useEffect(() => {
		setVisible(true);
	}, []);

	return <div className="certificates__img">
		<ImageWithSkeleton
			withLazy
			src={visible ? imageSize(`/remote/${item.image}`, '_thumb') : ''}
			onClick={onClick}
			onLoad={() => setLoading(false)}
		/>
		{loading ? <ContentLoader
			width="100%"
			height="100%"
			viewBox="0 0 450 450"
			backgroundColor="#f3f3f3"
			foregroundColor="#ecebeb"
			uniqueKey={item.id.toString()}
		>
			<rect x="0" y="0" rx="25" ry="25" width="100%" height="100%" />
		</ContentLoader> : null}
	</div>;
};

const Certificates: React.FC<Props> = ({ items }) => {
	const [colorboxIndex, setColorboxIndex] = React.useState<number | null>(null);

	if (items.length === 0) {
		return null;
	}

	const count = items.length;

	return <div className="certificates" style={{ minWidth: count > 4 ? 200 : (count * 46 + (count - 1) * 5) + 7 }}>
		<React.Fragment key="certificates">
			{items.filter((item) => item.certificate?.image).map((item, i) =>
				<CertificateComponent
					key={item.id}
					item={item.certificate}
					onClick={() => setColorboxIndex(i)}
				/>)}
		</React.Fragment>
		<Colorbox
			key="colorbox"
			files={items.map((s) => ({ file: { src: `remote/${s.certificate.image}` } }))}
			defaultIdx={colorboxIndex}
			onCancel={() => setColorboxIndex(null)}
			withDownload={false}
		/>
	</div>;
};

export default Certificates;
